
class Mapa {

    constructor(salaActual, salasPasadas, salasPosibles, vH, vG){
       
        this.salaActual = salaActual;
        this.salasPasadas = salasPasadas;
        this.salasPosibles = salasPosibles;
        this.vH = vH;
        this.vG = vG;
    }
}

export {Mapa}